import { PRIMARY_COLOR } from "@/app/layout/LayoutConstants";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

function Step({
  number,
  label,
  isActive,
  isCompleted,
}: {
  number: number;
  label: string;
  isActive: boolean;
  isCompleted: boolean;
}) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        whiteSpace: "nowrap",
        gap: 1,
      }}
    >
      <Typography
        variant="h6"
        sx={{
          backgroundColor:
            isActive || isCompleted ? PRIMARY_COLOR : "transparent",
          color: isActive || isCompleted ? "white" : "grey.700",
          borderColor: isActive || isCompleted ? "transparent" : PRIMARY_COLOR,
          borderWidth: 1,
          borderStyle: "solid",
          width: "30px",
          height: "30px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "100px",
        }}
      >
        {number}
      </Typography>
      <Typography
        sx={{
          color: isActive || isCompleted ? "inherit" : "grey.700",
          fontWeight: isActive ? "bold" : "normal",
        }}
      >
        {label}
      </Typography>
    </Box>
  );
}

const STEPS = [
  {
    label: "Category",
  },
  {
    label: "Details",
  },
  {
    label: "Publish",
  },
];

export default function Stepper({ activeStep }: { activeStep: number }) {
  return (
    <Box
      sx={{
        alignSelf: "center",
        display: "flex",
        gap: 4,
        overflowX: "auto",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": { display: "none" },
        maxWidth: "100%",
      }}
    >
      {STEPS.map((step, index) => {
        const number = index + 1;
        return (
          <Step
            key={index}
            number={number}
            label={step.label}
            isActive={activeStep === number}
            isCompleted={activeStep > number}
          />
        );
      })}
    </Box>
  );
}
